"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGION = void 0;
// optional window?. will be transpiled to  window === null || window === void 0 which would throw error
// prevent server side rendering to to do comparison on optional chaining window
var safeWindow = typeof window === 'undefined' ? undefined : window;
exports.REGION = (_a = safeWindow === null || safeWindow === void 0 ? void 0 : safeWindow._env_) === null || _a === void 0 ? void 0 : _a.REGION;
